// TODO(keep): Refactored file to keep
import { queryOptions } from '@tanstack/react-query'

import { staleTime } from '@/shared/constants/stale-time'
import { PaginationQueryParams } from '@/shared/schemas/pagination'

import { tagsApi } from './api'

export const tagsByIdQueryOptions = (id: string, filters: PaginationQueryParams) =>
  queryOptions({
    queryFn: () => tagsApi.getById(id, filters),
    queryKey: ['tags', 'byId', id, filters],
    staleTime: staleTime.ONE_MINUTE,
  })

export const tagsSearchByNameQueryOptions = (name: string) =>
  queryOptions({
    enabled: !!name,
    queryFn: () => tagsApi.searchByName(name),
    queryKey: ['tags', 'searchByName', name],
    staleTime: staleTime.ONE_MINUTE,
  })
